'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _query = require('utilities/query');

var _companyList = require('./company-list/company-list.module');

var _companyList2 = _interopRequireDefault(_companyList);

var _regulatorList = require('./regulator-list/regulator-list.module');

var _regulatorList2 = _interopRequireDefault(_regulatorList);

var _adminUserList = require('../admin-users/admin-user-list/admin-user-list.module');

var _adminUserList2 = _interopRequireDefault(_adminUserList);

var _adminUserAddForm = require('../admin-users/admin-user-add-form/admin-user-add-form.module');

var _adminUserAddForm2 = _interopRequireDefault(_adminUserAddForm);

var _adminUserEditForm = require('../admin-users/admin-user-edit-form/admin-user-edit-form.module');

var _adminUserEditForm2 = _interopRequireDefault(_adminUserEditForm);

var _companies = require('./companies.component');

var _companies2 = _interopRequireDefault(_companies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.companies', [_angularUiRouter2.default, _companyList2.default, _regulatorList2.default, _adminUserList2.default, _adminUserAddForm2.default, _adminUserEditForm2.default]).component('companies', _companies2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('companies', {
    parent: 'admin',
    url: '/companies',
    component: 'companies',
    resolve: {
      companyQuery: function companyQuery(CompanyService) {
        return CompanyService.getDefaultQuery();
      },
      user: function user(currentUser) {
        return currentUser;
      },
      companies: function companies(CompanyService, companyQuery) {
        return CompanyService.search(companyQuery).then(function (r) {
          return (0, _query.transformODataResponse)(r);
        });
      },
      regulatorQuery: function regulatorQuery(RegulatorService) {
        return RegulatorService.getDefaultQuery();
      },
      regulators: function regulators(regulatorQuery, RegulatorService) {
        return RegulatorService.search(regulatorQuery).then(function (r) {
          return (0, _query.transformODataResponse)(r);
        });
      },
      adminUsersQuery: function adminUsersQuery(PeopleService) {
        return PeopleService.getDefaultQuery();
      },
      adminUsers: function adminUsers(adminUsersQuery, PeopleService) {
        return PeopleService.search(adminUsersQuery).then(function (r) {
          return (0, _query.transformODataResponse)(r);
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/companies/companies.module.js